import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'ftp',
  name: 'FTP',
  category: 'files',
  description: 'Access and manage files on FTP and SFTP servers',
  icon: 'Server',
  color: 'rose',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: false,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  credentials: [
    {
      name: 'ftp',
      required: true,
      displayName: 'FTP Credentials',
    },
  ],
  subtitle: '={{ $parameter.operation }}',
};

export default definition;
